import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['text', 'value', 'total'],
  self: this,
  data: self => ({
    htmlLegend: null,
    options: {
      cutoutPercentage: 80,
      maintainAspectRatio: false,
      legend: {
        onClick: e => e.stopPropagation(),
        position: 'left',
        display: true,
        labels: {
          usePointStyle: true
        }
      },
      tooltips: {
        callbacks: {
          title: function(tooltipItem, data) {
            return (
              data['labels'][tooltipItem[0]['index']] +
              '                ' +
              ((data['datasets'][0]['data'][tooltipItem[0]['index']] * 100) / self.total).toFixed(2) +
              ' %'
            )
          },
          label: function(tooltipItem, data) {
            return data['datasets'][0]['data'][tooltipItem['index']] + `   ${self.text}`
          }
        },
        backgroundColor: 'rgba(114, 150, 232, 0.26)',
        titleFontSize: 16,
        titleFontColor: '#536DA8',
        bodyFontColor: '#536DA8',
        borderColor: '#7296E8',
        borderWidth: 2,
        bodyFontSize: 14,
        xPadding: 15,
        yPadding: 15,
        displayColors: false
      }
    }
  }),
  mounted() {
    this.renderChart(this.chartdata, this.options)
  }
}
